
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'


export default {
name: 'submitWork',
components: {
wx,XTextarea,Group,Popup,PopupHeader,XButton,Radio,
},
directives: {
TransferDom
},
data() {
return {
filePath: [],
conf: [],
confId:0,
cateId:0,
formData:{},
category:[],
pics:[],
grade:0,
store_id:0,
stores:[],
pickerStatus:false,
status:true,
store_name:'请选择',
code:''
}
},
created() {
this.getCategory();
this.config();
this.grade = parseInt(this.$func.getLocal('grade'));
if(this.grade == 13){
this.getStore();
}
},
methods: {
getCategory() {
this.$api.workCategory({}).then((res)=>{
if(res){
this.category = res.data;
this.cateId = res.data[0].id;
this.conf = res.data[0].conf;
}
})
},
cate(index,value){
this.cateId = value;
this.conf = this.category[index].conf;
this.formData = {};
this.code = '';
this.pics = [];
this.filePath = [];
this.confId = 0;
},
submit() {
if(!this.status){
return false;
}
this.status = false;
this.formData.code = this.code;
this.formData.cate_id = this.cateId;
this.formData.store_id = this.store_id;
this.formData.pics = JSON.stringify(this.pics);
this.$api.submitWork(this.formData).then((res)=>{
if(res){
this.formData = {};
this.code = '';
this.pics = [];
this.filePath = [];
this.confId = 0;
this.cateId = this.category[0].id;
this.$func.showToast('提交成功');
this.status = true;
}
})
},
onStore (value) {
this.store_id = value;
},
confirmStore () {
let that = this;
this.stores.forEach((item,index)=>{
if(item.key == that.store_id){
that.store_name = item.value
}
})
this.pickerStatus = false;
},
getStore(){
this.$api.store({}).then((res)=>{
if(res){
this.stores = res.data;
}
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
"scanQRCode"
]
});
}
})
},
uploadFile(value){
let that = this;
this.confId = value;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let that = this;
let localId = localIds.pop();
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId,path:'work'}).then((res)=>{
if(res){
that.filePath.push({key:that.confId,value:res.data.url});
that.pics.push({key:that.confId,value:res.data.path});
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(index) {
wx.previewImage({
current: this.filePath[index].value, // 当前显示图片的http链接
urls: [this.filePath[index].value] 
});
},
delImg(index){
this.filePath.splice(index,1);
this.pics.splice(index,1);
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ["qrCode","barCode"],
success: function (res) {
setTimeout(()=>{

that.code = that.$func.parseScanResult(res.resultStr);
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/submitWork.vue